import React, { ReactNode, useState } from "react";
import { ErrorBoundary, NavigationBar, ActionBottomBar } from "../components";
import { useBaseLayoutStyles } from "./css";
import { BaseLayoutContext } from "../contexts/Contexts";

interface IBaseLayout {
  children: ReactNode;
  moduleName?: string;
  modulePath?: string;
  isDocumentList?: boolean;
  button?: {
    btnIcon?: React.ReactNode;
    btnText?: string;
    btnOnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    btnLink?: string;
  };
}

export default function BaseLayout(props: IBaseLayout) {
  const {
    children,
    moduleName,
    button,
    modulePath,
    isDocumentList = false,
  } = props;
  const { classes } = useBaseLayoutStyles();
  const [noRows, setNoRows] = useState(false);

  const setNoRowsInList = (value: boolean) => {
    setNoRows(value);
  };

  return (
    <BaseLayoutContext.Provider
      value={{ setNoRowsInList, buttonSettings: { ...button } }}
    >
      <div className={classes.layout}>
        <NavigationBar
          moduleName={moduleName}
          modulePath={modulePath}
          isDocumentList={isDocumentList}
        />
        <ErrorBoundary>{children}</ErrorBoundary>

        {!noRows && button && <ActionBottomBar {...button} />}
      </div>
    </BaseLayoutContext.Provider>
  );
}
